import socialMediaApi from '@/api/socialMedia.api'

const state = {
  socialMedias: []
}


const getters = {
  socialMediaById: (state) => (id) => {
    return state.socialMedias.find(x => x.id === id)
  },

  socialMedias: (state) => {
    return state.socialMedias.filter(x => x.id === 2)
  }
}


const actions = {
  async loadSocialMedias ({ commit, rootState }) {
    const response = await socialMediaApi.getSocialMedias(rootState.tenant.current)
    commit('SET_SOCIAL_MEDIAS', response.data)
  }
}


const mutations = {
  SET_SOCIAL_MEDIAS (state, socialMedias) {
    state.socialMedias = socialMedias
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
